import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bell, Check, Banknote, RefreshCw, Home } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const REQUEST_TYPES = [
  { id: "supervisor", label: "طلب المشرف", icon: Bell, color: "bg-blue-600" },
  { id: "exchange", label: "طلب صرافة", icon: Banknote, color: "bg-emerald-600" },
  { id: "change", label: "طلب تبديل", icon: RefreshCw, color: "bg-yellow-400" },
];

const CashierScreen = () => {
  const { cashNumber } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sentType, setSentType] = useState(null);

  const handleRequest = async (requestType) => {
    if (loading) return;
    
    setLoading(true);
    try {
      await axios.post(`${API}/calls`, {
        cash_number: parseInt(cashNumber),
        request_type: requestType,
      });
      setSentType(requestType);
      toast.success("تم الإرسال");
      
      setTimeout(() => setSentType(null), 2000);
    } catch (error) {
      console.error("Error:", error);
      toast.error("خطأ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      {/* زر الرجوع */}
      <button
        onClick={() => navigate("/")}
        className="absolute top-4 right-4 w-12 h-12 bg-slate-700 hover:bg-slate-600 rounded-xl flex items-center justify-center transition-colors"
      >
        <Home className="w-6 h-6 text-white" />
      </button>

      {/* أزرار الطلبات - عمودي */}
      <div className="flex flex-col gap-3">
        {REQUEST_TYPES.map((type) => {
          const Icon = type.icon;
          const isSent = sentType === type.id;
          
          return (
            <button
              key={type.id}
              data-testid={`request-${type.id}-btn`}
              onClick={() => handleRequest(type.id)}
              disabled={loading || isSent}
              style={{ width: '75px', height: '75px' }}
              className={`rounded-xl flex flex-col items-center justify-center gap-1 transition-all duration-150 active:scale-90 shadow-lg ${
                isSent ? "bg-emerald-500" : type.color
              }`}
            >
              {isSent ? (
                <Check className="w-8 h-8 text-white" strokeWidth={3} />
              ) : (
                <>
                  <Icon className="w-6 h-6 text-white" />
                  <span className="text-[7px] font-bold text-white leading-tight text-center px-1">
                    {type.label}
                  </span>
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CashierScreen;
